/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./Header/Header"
import "./layout.scss"
import Newsletter from "./Newsletter/Newsletter"
import BookingFooter from "../components/common/blockBooking/blockBookingFooter"
import { useEffect, useState, useCallback } from "react"
import { useIntl } from "gatsby-plugin-react-intl"
import FooterContainer from "./Footer/Footer"
import { debounce, getHotelBookingCode } from "./functions"
import { HOTEL_TAXONOMY_VERANDA_GRAND_BAIE_ID, HOTEL_TAXONOMY_VERANDA_PALMAR_BEACH_ID, HOTEL_TAXONOMY_VERANDA_PAUL_VIRGINIE_ID, HOTEL_TAXONOMY_VERANDA_POINTE_AUX_BICHES_ID, HOTEL_TAXONOMY_VERANDA_TAMARIN_ID } from "../constants"
import { ParallaxProvider } from 'react-scroll-parallax';
import BlockBooking from "./common/blockBooking/blockBooking"
import CartLink from "./Header/cartLink"
import { useContext } from "react"
import CartContext from "../context/CartContext"

const Layout = ({ children, pageContext, pageClass }) => {
  const containerRef = React.useRef(null)
  const intl = useIntl()
  const [lang, setLang] = useState("")
  const {visible,experiences} = useContext(CartContext)

  useEffect(() => {
    const langBtns = document.querySelectorAll(".blk-langue button")
    langBtns.forEach(langBtn => {
      if (!langBtn.classList.contains("inactive")) {
        setLang(langBtn.innerText.toLowerCase())
      }
    })
  }, [])
  
  useEffect(() => {
    //Timeout after 2s
    setTimeout(() => {
      document.body.classList.add("pageLoaded")
    }, 2000)
  }, [containerRef])

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      mainMenu_en: allMenuLinkContentMain(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "en" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...mainMenuFields
      }
      mainMenu_fr: allMenuLinkContentMain(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "fr" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...mainMenuFields
      }
      menuPV_en: allMenuLinkContentVerandaPaulVirginieMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "en" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuPV
      }
      menuPV_fr: allMenuLinkContentVerandaPaulVirginieMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "fr" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuPV
      }
      menuGB_en: allMenuLinkContentVerandaGrandBaieMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "en" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuGB
      }
      menuGB_fr: allMenuLinkContentVerandaGrandBaieMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "fr" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuGB
      }
      menuPB_en: allMenuLinkContentVerandaPalmarBeachMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "en" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuPB
      }
      menuPB_fr: allMenuLinkContentVerandaPalmarBeachMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "fr" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuPB
      }
      menuPAB_en: allMenuLinkContentVerandaPointeAuxBichesMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "en" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuPAB
      }
      menuPAB_fr: allMenuLinkContentVerandaPointeAuxBichesMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "fr" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuPAB
      }
      menuTA_en: allMenuLinkContentVerandaTamarinMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "en" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuTA
      }
      menuTA_fr: allMenuLinkContentVerandaTamarinMenu(
        filter: {
          enabled: { eq: true }
          title: { ne: "Dummy" }
          langcode: { eq: "fr" }
        }
        sort: { fields: weight, order: ASC }
      ) {
        ...menuTA
      }
    }
  `)

  let allMenus, allMenuEN, allMenuFR

  switch (pageContext.hotelTaxonomyDrupalId) {
    case HOTEL_TAXONOMY_VERANDA_PAUL_VIRGINIE_ID:
      allMenuEN = data.menuPV_en
      allMenuFR = data.menuPV_fr
      break;
    case HOTEL_TAXONOMY_VERANDA_GRAND_BAIE_ID:
      allMenuEN = data.menuGB_en
      allMenuFR = data.menuGB_fr
      break;
    case HOTEL_TAXONOMY_VERANDA_PALMAR_BEACH_ID:
      allMenuEN = data.menuPB_en
      allMenuFR = data.menuPB_fr
      break;
    case HOTEL_TAXONOMY_VERANDA_POINTE_AUX_BICHES_ID:
      allMenuEN = data.menuPAB_en
      allMenuFR = data.menuPAB_fr
      break;
    case HOTEL_TAXONOMY_VERANDA_TAMARIN_ID:
      allMenuEN = data.menuTA_en
      allMenuFR = data.menuTA_fr
      break;
    default:
      allMenuEN = data.mainMenu_en
      allMenuFR = data.mainMenu_fr
      break
  }

  let locale

  //check if property localeBlog exists in pageContext
  if (pageContext.localeBlog) {
    locale = pageContext.localeBlog.toLowerCase()
  } else {
    locale = intl.locale
  }

  switch (locale) {
    case "fr":
      allMenus = allMenuFR.nodes
      break
    default:
      allMenus = allMenuEN.nodes
  }

  const hashTable = Object.create(null)
  allMenus.forEach(
    menu => (hashTable[menu.drupal_id] = { ...menu, childNodes: [] })
  )

  const menuTree = []
  allMenus.forEach(menu => {
    if (menu.drupal_parent_menu_item) {
      const stripped_drupal_id = menu.drupal_parent_menu_item.replace(
        "menu_link_content:",
        ""
      )

      hashTable[stripped_drupal_id]?.childNodes?.push(hashTable[menu.drupal_id])
    } else {
      menuTree.push(hashTable[menu.drupal_id])
    }
  })

  const [y, setY] = useState("0")

  const handleNavigation = useCallback(
    e => {
      const window = e.currentTarget

      if (y > window.scrollY) {
        document.body.classList.add("scroll-up")
        document.body.classList.remove("scroll-down")
        document.body.classList.remove("top")
      } else if (y < window.scrollY) {
        document.body.classList.add("scroll-down")
        document.body.classList.remove("scroll-up")
        document.body.classList.remove("top")
      }
      if (window.scrollY === 0) {
        document.body.classList.remove("scroll-up")
        document.body.classList.remove("scroll-down")
        document.body.classList.add("top")
        //document.querySelector('#btnUp').classList.remove('show')
      }
      // if (window.scrollY > 300) {
      //   document.querySelector('#btnUp').classList.add('show')
      // }
      setY(window.scrollY)
    },
    [y]
  )

  useEffect(() => {

    setY(window.scrollY)

    window.addEventListener("scroll", handleNavigation)

    window.addEventListener('keydown', e => {
      //console.log(e.key)
      const elem = document.querySelector(".mainBanner")
      if (e.key === "ArrowDown" || e.key === "End" || e.key === "PageDown") {
        document.body.classList.remove("scroll-up")
        document.body.classList.remove("scroll-down")
        document.body.classList.add("scroll-down")
      }
      if (e.key === "ArrowUp" || e.key === "Home" || e.key === "PageUp") {
        document.body.classList.remove("scroll-up")
        document.body.classList.remove("scroll-down")
        document.body.classList.add("scroll-up")
      }
      if (elem?.classList?.contains("is-reveal")) {
        document.body.classList.remove("scroll-up")
      }
    })

    return () => {
      window.removeEventListener("scroll", handleNavigation)
    }
  }, [handleNavigation])

  return (
    <div
      id="global"
      className={pageClass}
    >
      <Header
        siteTitle={data.site.siteMetadata?.title || `Title`}
        pageContext={pageContext}
        menus={menuTree}
      />
      {/*<h1 className="screen-reader-text">{pageTitle}</h1>*/}

      {experiences.length > 0 && (<CartLink show={visible}/>)}
      <ParallaxProvider>
        <main ref={containerRef}>
          {children}
          <BlockBooking hotel={getHotelBookingCode(pageContext.hotelTaxonomyDrupalId)} roomId={pageContext.roomId} locale={lang} />
          <Newsletter locale={locale} />
          {/* <FooterContainer locale={locale} /> */}
          <FooterContainer locale={locale} />
          <BookingFooter locale={locale} />
        </main>
      </ParallaxProvider>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
